var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "global-alert text-xs",
      class: {
        show: _vm.alert != null && !_vm.forceHide,
        "show-max": _vm.maximize,
      },
    },
    [
      _c("div", { staticClass: "alert-inner" }, [
        _c(
          "div",
          { staticClass: "alert-mini", on: { click: _vm.handleMaximize } },
          [
            _c("i", {
              staticClass: "fa fa-times",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.hide($event)
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "left-item alert-type" }, [
              _vm.getIconAccessory != null
                ? _c("i", {
                    staticClass:
                      "d-flex align-items-center justify-content-center",
                    domProps: { innerHTML: _vm._s(_vm.getIconAccessory) },
                  })
                : _c("i", { class: _vm.alert.event_type_icon }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infos" }, [
              _c("span", [
                _c("strong", [
                  _c("span", { staticClass: "upper" }, [
                    _vm._v(_vm._s(_vm.alert.event_type_label)),
                  ]),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("global.alert.triggered")) +
                      " " +
                      _vm._s(_vm.formatDate) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _vm.alert.identification_name
                  ? _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("global.by")) +
                          " " +
                          _vm._s(_vm.alert.identification_name) +
                          " (" +
                          _vm._s(_vm.alert.dati_name) +
                          ")\n          "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.alert.identification_name
                  ? _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("global.alert.byDevice")) +
                          " " +
                          _vm._s(_vm.alert.dati_name) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("strong", [_vm._v("N° " + _vm._s(_vm.alertNumber))]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "alert-maxi" },
          [
            _c("i", {
              staticClass: "fa fa-times",
              on: { click: _vm.handleMinimize },
            }),
            _vm._v(" "),
            _c("iframe", { attrs: { src: _vm.getUrl } }),
            _vm._v(" "),
            _c("Btn", {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "beepiz-edit-alerts",
                  expression: "'beepiz-edit-alerts'",
                },
              ],
              staticClass: "block success",
              domProps: { innerHTML: _vm._s(_vm.$t("alerts.btns.ack")) },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.dismissAlert($event)
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }